import ReportsDock, {ReportsDockExtensionProps} from 'modules/reports/components/Dock'
import ReportsDockBody from 'modules/reports/components/Dock/Body'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
// import useStyles from './ReportsEditFiltersDock.styles'

type Props = ReportsDockExtensionProps & {}

function ReportsEditFiltersDock(props: Props) {
  // const classes = useStyles()
  const {p} = useCore('reports', 'docks', 'EditFilters')

  return (
    <ReportsDock {...props} data-testid={p()}>
      <ReportsDockBody width={260}>Fields</ReportsDockBody>
    </ReportsDock>
  )
}

export default ReportsEditFiltersDock
